import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" ref={ref} {...props}>
        <path
            fill="#A8ACBD"
            d="M3 9.53c0 1.665 1.32 3.015 2.948 3.015h1.408L8.53 9.369h3.57l-.817 2.405H13.5l-.53.77h1.488c1.404 0 2.542-1.164 2.542-2.6 0-1.436-1.138-2.6-2.542-2.6-.149 0-.293.016-.435.041C13.796 5.478 12.207 4 10.281 4l-.038.001-.037.002c-1.626.033-3 1.117-3.497 2.616a2.89 2.89 0 0 0-.76-.104C4.32 6.515 3 7.865 3 9.529Z"
        />
        <path
            fill="#FFB41F"
            fillRule="evenodd"
            d="M8.973 9.966h2.24l-.84 2.417h1.96l-3.36 4.742.653-3.424h-1.96l1.307-3.735Z"
            clipRule="evenodd"
        />
    </svg>
);
const ForwardRef = forwardRef(SvgComponent);
export default ForwardRef;
